import api from '@/api/index.js'

const top_ups = {
  state: {
    loading: false,
    data: [],
    filterDetails: null,
    error: null
  },

  mutations: {
    SET_TOP_UPS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_TOP_UPS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_TOP_UPS_ERROR: (state, error) => {
      state.error = error
    },
    SET_TOP_UPS_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadTopUps({commit}, query) {
      commit('SET_TOP_UPS_LOADING', true)
      commit('SET_TOP_UPS_FILTER_DETAILS', query)
      commit('SET_TOP_UPS_ERROR', null)
      return api.get(`top-ups?date=${query.date?query.date:""}&amount=${query.amount}&merchant_reference=${query.merchantReference}&limit=150&offset=0`)
        .then((response) => {
          commit('SET_TOP_UPS', response)
        })
        .catch((error) => {
          commit('SET_TOP_UPS_ERROR', error.body)
          commit('SET_TOP_UPS_LOADING', false)
        })
    }
  }
}

export default top_ups
